export enum CommMethodEnum {
  ValidValue  = '02F8445F-6BA3-4AE3-A3EF-2AED75C3C56D',
  Phone       = '00000009-1000-0000-0000-000000000001',
  Fax         = '00000009-1000-0000-0000-000000000002',
  Mobile      = '00000009-1000-0000-0000-000000000003',
  Email       = '00000009-1000-0000-0000-000000000004'
}
